import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";

import { Seo } from "src/components/seo";
import { usePageView } from "src/hooks/use-page-view";

import Markdown from "react-markdown";
import { PluggableList } from "react-markdown/lib";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";
import { markdownComponents } from "../dashboard/helpers/markdownlhelpers";
import { legalnotice_website } from "./legalnotice-website";

interface Item {
  image: string;
  newTab?: boolean;
  path: string;
  subtitle: string;
  title: string;
}

interface Section {
  title: string;
  items: Item[];
}

const LegalNoticePage = () => {
  const theme = useTheme();

  usePageView();

  return (
    <>
      <Seo title="Legal Notice" />
      <Box
        sx={{
          backgroundColor: (theme) =>
            theme.palette.mode === "dark" ? "neutral.800" : "neutral.50",
          flexGrow: 1,
          py: 15,
        }}
      >
        <Container maxWidth="md">
          <Stack spacing={1}>
            <Box textAlign="center">
              <Typography variant="h3">Terms and conditions</Typography>
            </Box>
            <Typography color="text.primary" variant="body1">
              <Markdown
                children={legalnotice_website}
                components={markdownComponents}
                remarkPlugins={[remarkGfm]}
                rehypePlugins={[rehypeRaw] as PluggableList}
              />
            </Typography>
          </Stack>
        </Container>
      </Box>
    </>
  );
};

export default LegalNoticePage;
